const SELECTORS = Selectors({
    map: '#office-location-map'
})

const props = {
    $map: document.querySelector(SELECTORS.map)
}

const fn = {
    init: () => {
        if (props.$map) {
            fn.setupMap()
        }
    },

    setupMap: () => {

        const mapEl = props.$map
        const data = JSON.parse(mapEl.dataset.json)

        const mapOptions = {
            center: new google.maps.LatLng(data.lat, data.lng),
            zoom: 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            scrollwheel: false,
            gestureHandling: 'none',
            styles: [
                {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [{ visibility: 'off' }],
                }
            ]
        }

        const map = new google.maps.Map(mapEl, mapOptions)
        const bounds = new google.maps.LatLngBounds()

        google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
            const icanMarker = {
                url: "data:image/svg+xml;base64,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",
                scaledSize: new google.maps.Size(39, 53),
            }
            const marker = new google.maps.Marker({
                map: map,
                title: data.title,
                animation: google.maps.Animation.DROP,
                position: new google.maps.LatLng(data.lat, data.lng),
                panposition: new google.maps.LatLng(data.lat, data.lng),
                icon: icanMarker,
            })

            google.maps.event.addListener(marker, 'click', () => {
                window.open(data.url, '_blank')
            })

            google.maps.event.addListener(marker, 'mouseover', function () {
                this.setAnimation(google.maps.Animation.BOUNCE)
            })

            google.maps.event.addListener(marker, 'mouseout', function () {
                this.setAnimation(null)
            })

            bounds.extend(marker.getPosition())
        })

    }

}

export default {
  can: () => document.body.classList.contains('pagetype-officepage'),
  run: fn.init
}
